import { Space, Typography } from "antd";
const { Text } = Typography;

const PrintContent = ({
  colunas,
  dados,
  campanha,
  formulario,
  observacoes = "",
  parametro,
  totalConlcluidos,
  totalRespostas,
  totalPontuacao,
  percentual,
  tipoRelatorio = "detalhado",
}) => {
  const summary_coluns = [];
  for (let index = 1; index < colunas?.length; index++) {
    let col = 0;
    dados?.forEach((e) => {
      col += parseInt(e?.[colunas[index]?.dataIndex] ?? 0);
    });
    summary_coluns.push(col);
  }

  return (
    <div className="print-container">
      <Space direction="vertical">
        <Text className="line-break" style={{ fontSize: 16 }}>
          <strong>Campanha:</strong> {campanha}
        </Text>
        <Text className="line-break" style={{ fontSize: 16 }}>
          <strong>Formulário:</strong> {formulario}
        </Text>
        <Text className="line-break" style={{ fontSize: 16 }}>
          <strong>Parâmetro Avaliado:</strong> {parametro}
        </Text>
        <Text className="line-break" style={{ fontSize: 14 }}>
          {observacoes}
        </Text>
      </Space>
      <br />
      <br />
      <table className="print-table table-print-portrait">
        <thead>
          <tr>
            {colunas?.map((col) => {
              return (
                <th key={col?.title} style={{ width: col?.width }}>
                  {col?.title}
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {dados?.map((row) => (
            <>
              <tr key={`${row?.id}_group`}>
                {colunas?.map((col, index) =>
                  tipoRelatorio === "detalhado" ? (
                    <th key={index}>{row?.[col?.dataIndex]}</th>
                  ) : (
                    <td key={index}>{row?.[col?.dataIndex]}</td>
                  )
                )}
              </tr>

              {tipoRelatorio === "detalhado" &&
                row?.questoes?.map((rowQuestions) => (
                  <tr key={`${row?.id}_question`}>
                    {colunas?.map((col, index) => (
                      <td style={{ paddingLeft: index == 0 ? 20 : 5, width: col?.width }} key={index}>
                        {rowQuestions?.[col?.dataIndex]}
                      </td>
                    ))}
                  </tr>
                ))}
            </>
          ))}
        </tbody>
        <tfoot>
          <tr>
            <th></th>
            <th>{totalRespostas}</th>
            <th>{totalPontuacao}</th>
            <th>{percentual}</th>
          </tr>
          <tr>
            <th>Total Respondentes (Concluídos)</th>
            <th colSpan={3}>{totalConlcluidos}</th>
          </tr>
        </tfoot>
      </table>
      <br />
    </div>
  );
};

export { PrintContent };
